export default "__VITE_ASSET__d63d1df4__"